const desktop = "@media only screen and (min-width: 992px)";
const tablet = "@media only screen and (min-width: 767px)";
const mobile = "@media only screen and (max-width: 479px)";

export default {desktop, tablet, mobile};